module.exports = __webpack_public_path__ + "img/ic-ic-filter.ce0f5ba2.svg";